import { useState, useEffect, useRef } from "react";
import signalSvg from "../assets/signal.svg";
import speedometerSvg from "../assets/speedometer.svg";
import insightSvg from "../assets/insight.svg";
import methodSvg from "../assets/method.svg";
import goalSvg from "../assets/goal.svg";






const slides = [
  {
    number: 1,
    tag: "THE PROBLEM",
    graphic: <img src={signalSvg} alt="Signal" style={{ width: "100%", height: "100%", objectFit: "contain" }} />,
    content: (
      <>
        <p className="slide-main-text">
          Most leaders are not short on ambition.<br />
          They are drowning in operational noise.
        </p>
        <p className="slide-body-text">
          The real problem is not productivity.<br />
          <strong>It's the inability to separate SIGNAL from NOISE.</strong>
        </p>
        <p className="slide-highlight" style={{ marginTop: "0.5rem" }}>vectr42 is built to make signal visible again.</p>
      </>
    ),
  },
  {
    number: 2,
    tag: "THE CHALLENGE",
    graphic: <img src={speedometerSvg} alt="Speedometer" style={{ width: "100%", height: "100%", objectFit: "contain" }} />,
    content: (
      <>
        <p className="slide-main-text" style={{ background: "#cfcece", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700 }}>Not all work has equal strategic value.</p>
        <p className="slide-body-text" style={{ background: "#cecece", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700 }}>vectr42 helps leaders distinguish between:</p>
        <p className="slide-highlight">· Strategic vs. Operational</p>
        <p className="slide-highlight">· Control vs. Influence vs. Beyond Influence</p>
        <p className="slide-body-text" style={{ marginTop: "0.2rem", background: "#ffffff", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700 }}>
          Because moving the needle requires strategic focus and not endless operational activity.
        </p>
      </>
    ),
  },
  {
    number: 3,
    tag: "THE INSIGHT",
    graphic: <img src={insightSvg} alt="Insight" style={{ width: "100%", height: "100%", objectFit: "contain" }} />,
    content: (
      <>
        <p className="slide-main-text" style={{ background: "#ffffff", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700 }}>How to apply the vectr42 framework.</p>
        {[
          ["Classify activities:", "Strategic vs. Operational, Control vs. Influence vs. Beyond."],
          ["Prioritise the strategic row -", "structural moves over busywork."],
          ["Protect execution capacity", "from operational drag."],
          ["Discipline the loop", "with vectrMode and the Weekly Mirror."],
        ].map(([line1, line2], i) => (
          <p key={i} className="slide-body-text" style={{ background: "#cecece", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700, fontSize: "12.5px", marginBottom: "0.1rem" }}>
            {line1}<br />{line2}
          </p>
        ))}
      </>
    ),
  },
  {
    number: 4,
    graphicWidth: "240px",
    tag: "THE METHOD",
    graphic: <img src={methodSvg} alt="Method" style={{ width: "100%", height: "100%", objectFit: "contain" }} />,
    content: (
      <>
        <p className="slide-main-text" style={{ background: "#cfcece", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontSize: "13.5px" }}>The goal isn't getting more done.</p>
        <p className="slide-main-text" style={{ background: "#ffffff", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontSize: "14.5px", fontWeight: 700, marginTop: "0.4rem" }}>
          The goal is protecting strategic attention.
        </p>
        <p className="slide-body-text" style={{ background: "#ffffffcc", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontSize: "14.5px", marginTop: "0.4rem" }}>
          When leaders spend their energy reacting and maintaining, reinvention becomes impossible.
        </p>
        <p className="slide-highlight" style={{ background: "#ff820f", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700, marginTop: "0.4rem" }}>
          vectr42 builds discipline around what actually moves the needle.
        </p>
      </>
    ),
  },
  {
    number: 5,
    graphicWidth: "250px",
    tag: "THE GOAL",
    graphic: <img src={goalSvg} alt="Goal" style={{ width: "100%", height: "100%", objectFit: "contain" }} />,
    content: (
      <>
        <p className="slide-main-text">
          <span style={{ background: "#ffffff", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700, fontSize: "14.5px" }}>High performers don't protect their time.</span><br />
          <span style={{ background: "#ff6b1a", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700, fontSize: "14.5px" }}>They protect their attention.</span>
        </p>
        <div style={{ marginTop: "0.3rem" }}>
          <p className="slide-body-text" style={{ marginBottom: "0.4rem", background: "#ffffff", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>They manage :</p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.25rem 0.5rem" }}>
            {["strategic focus", "commitment depth", "energy allocation", "attention discipline"].map((item, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <span style={{ color: "#ff6a00", fontWeight: 700, fontSize: "15.5px", WebkitTextFillColor: "#ff6a00" }}>·</span>
                <span style={{ background: "#ffffff", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700, fontSize: "14.5px" }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
        <p className="slide-highlight" style={{ background: "#ff6b1a", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", fontWeight: 700, marginTop: "0.6rem" }}>
          vectr42 helps leaders move the needle every single day.
        </p>
      </>
    ),
  },
];

const IdeaSlider = () => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [instantJump, setInstantJump] = useState(false);
  const trackRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIndex(0);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardPercent = isMobile ? 100 : 70;
  const renderSlides = [...slides, slides[0], slides[1]];

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const handleTransitionEnd = (e) => {
      if (e.propertyName === "transform" && index === slides.length) {
        setInstantJump(true);
        setIndex(0);
      }
    };
    track.addEventListener("transitionend", handleTransitionEnd);
    return () => track.removeEventListener("transitionend", handleTransitionEnd);
  }, [index]);

  useEffect(() => {
    if (instantJump) {
      const frame = requestAnimationFrame(() => {
        requestAnimationFrame(() => setInstantJump(false));
      });
      return () => cancelAnimationFrame(frame);
    }
  }, [instantJump]);

  return (
    <section className="idea-slider">
      <div className="idea-slider-header">
        <p className="idea-slider-label">Designed for impact</p>
        <h2 className="idea-slider-title">Idea behind vectr42</h2>
      </div>

      <div className="idea-slider-wrapper">
        <button
          className="slider-arrow slider-arrow-left"
          onClick={() => setIndex((i) => Math.max(i - 1, 0))}
          disabled={index === 0}
        >
          &#8592;
        </button>

        <div className="slider-viewport">
          <div
            ref={trackRef}
            className="slider-track"
            style={{
              transform: `translateX(-${index * cardPercent}%)`,
              transition: instantJump ? "none" : undefined,
            }}
          >
            {renderSlides.map((slide, i) => (
              <div className="slide-card" key={`${slide.number}-${i}`}>
                <div className="slide-text-side">
                  <div className="slide-tag-row">
                    <span className="slide-number">{slide.number}</span>
                    <span className="slide-tag">{slide.tag}</span>
                  </div>
                  <div className="slide-content">{slide.content}</div>
                </div>
                <div className="slide-graphic-side" style={slide.graphicWidth ? { width: slide.graphicWidth } : {}}>{slide.graphic}</div>
              </div>
            ))}
          </div>
        </div>

        <button
          className="slider-arrow slider-arrow-right"
          onClick={() => setIndex((i) => (i >= slides.length ? i : i + 1))}
        >
          &#8594;
        </button>
      </div>

      <div className="slider-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`slider-dot ${i === index % slides.length ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default IdeaSlider;
